import { AlertProps as AAlertProps } from 'antd';
import { StyledAlert } from './styles';

export type AlertProps = AAlertProps & { iconAlign?: 'center' | 'flex-start' };

const Alert = ({ iconAlign, ...props }: AlertProps) => <StyledAlert $iconAlign={iconAlign} {...props} />;

Alert.displayName = 'Alert';
export default Alert;
